import '../assets/NcPopover-wrgZy49g.css';
import s, { defineComponent as a } from "vue";
import { Dropdown as i } from "floating-vue";
import { createFocusTrap as p } from "focus-trap";
import { g as u } from "./focusTrap-Be9GEB5C.mjs";
import { n } from "./_plugin-vue2_normalizer-Bj5bLKV4.mjs";
const l = a({
  name: "NcPopoverTriggerProvider",
  provide() {
    return {
      "NcPopover:trigger:shown": () => this.shown,
      "NcPopover:trigger:attrs": () => this.triggerAttrs
    };
  },
  props: {
    shown: {
      type: Boolean,
      required: !0
    },
    popupRole: {
      type: String,
      default: void 0
    }
  },
  computed: {
    triggerAttrs() {
      return {
        "aria-haspopup": this.popupRole,
        "aria-expanded": this.shown.toString()
      };
    }
  },
  render() {
    var e, t;
    return (t = (e = this.$scopedSlots).default) == null ? void 0 : t.call(e, {
      attrs: this.triggerAttrs
    });
  }
}), c = null, d = null;
var g = /* @__PURE__ */ n(
  l,
  c,
  d,
  !1,
  null,
  null,
  null,
  null
);
const h = g.exports, f = {
  name: "NcPopover",
  components: {
    Dropdown: i,
    NcPopoverTriggerProvider: h
  },
  inheritAttrs: !1,
  props: {
    /**
     * Show or hide the popper
     * @see https://floating-vue.starpad.dev/api/#shown
     */
    shown: {
      type: Boolean,
      default: !1
    },
    /**
     * Popup role
     * @see https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-haspopup#values
     */
    popupRole: {
      type: String,
      default: void 0,
      validator: (e) => ["menu", "listbox", "tree", "grid", "dialog", "true"].includes(e)
    },
    popoverBaseClass: {
      type: String,
      default: ""
    },
    /**
     * Enable popover focus trap
     */
    focusTrap: {
      type: Boolean,
      default: !0
    },
    /**
     * Set element to return focus to after focus trap deactivation
     *
     * @type {import('focus-trap').FocusTargetValueOrFalse}
     */
    setReturnFocus: {
      default: void 0,
      type: [HTMLElement, SVGElement, String, Boolean]
    }
  },
  emits: [
    "after-show",
    "after-hide",
    /**
     * @see https://floating-vue.starpad.dev/api/#update-shown
     */
    "update:shown"
  ],
  data() {
    return {
      internalShown: this.shown
    };
  },
  watch: {
    shown(e) {
      this.internalShown = e;
    },
    internalShown(e) {
      this.$emit("update:shown", e);
    }
  },
  mounted() {
    this.checkTriggerA11y();
  },
  beforeDestroy() {
    this.clearFocusTrap(), this.clearEscapeStopPropagation();
  },
  methods: {
    /**
     * Check if the trigger has all required a11y attributes.
     * Important to check custom trigger button.
     */
    checkTriggerA11y() {
      var e;
      (e = window.OC) != null && e.debug && (this.getPopoverTriggerContainerElement().querySelector("[aria-expanded]") || s.util.warn("It looks like you are using a custom button as a <NcPopover> or other popover #trigger. If you are not using <NcButton> as a trigger, you need to bind attrs from the #trigger slot props to your custom button. See <NcPopover> docs for an example."));
    },
    /**
     * Remove incorrect aria-describedby attribute from the trigger.
     * @see https://github.com/Akryum/floating-vue/blob/8d4f7125aae0e3ea00ba4093d6d2001ab15058f1/packages/floating-vue/src/components/Popper.ts#L734
     */
    removeFloatingVueAriaDescribedBy() {
      const t = this.getPopoverTriggerContainerElement().querySelectorAll("[data-popper-shown]");
      for (const r of t)
        r.removeAttribute("aria-describedby");
    },
    /**
     * @return {HTMLElement|undefined}
     */
    getPopoverContentElement() {
      var e, t;
      return (t = (e = this.$refs.popover) == null ? void 0 : e.$refs.popperContent) == null ? void 0 : t.$el;
    },
    /**
     * @return {HTMLElement|undefined}
     */
    getPopoverTriggerContainerElement() {
      return this.$refs.popover.$refs.reference;
    },
    /**
     * Add focus trap for accessibility.
     */
    async useFocusTrap() {
      if (await this.$nextTick(), !this.focusTrap)
        return;
      const e = this.getPopoverContentElement();
      e && (this.$focusTrap = p(e, {
        // Prevents to lose focus using esc key
        // Focus will be release when popover be hide
        escapeDeactivates: !1,
        allowOutsideClick: !0,
        setReturnFocus: this.setReturnFocus,
        trapStack: u()
      }), this.$focusTrap.activate());
    },
    /**
     * Remove focus trap
     *
     * @param {object} options The configuration options for focusTrap
     */
    clearFocusTrap(e = {}) {
      var t;
      try {
        (t = this.$focusTrap) == null || t.deactivate(e), this.$focusTrap = null;
      } catch (r) {
        console.warn(r);
      }
    },
    /**
     * Add stopPropagation for Escape.
     * It prevents global Escape handling after closing popover.
     *
     * Manual event handling is used here instead of v-on because there is no direct access to the node.
     * Alternative - wrap <template #popover> in a div wrapper.
     */
    addEscapeStopPropagation() {
      const e = this.getPopoverContentElement();
      e == null || e.addEventListener("keydown", this.stopKeydownEscapeHandler);
    },
    /**
     * Remove stop Escape handler
     */
    clearEscapeStopPropagation() {
      const e = this.getPopoverContentElement();
      e == null || e.removeEventListener("keydown", this.stopKeydownEscapeHandler);
    },
    /**
     * @param {KeyboardEvent} event - native keydown event
     */
    stopKeydownEscapeHandler(e) {
      e.type === "keydown" && e.key === "Escape" && e.stopPropagation();
    },
    afterShow() {
      this.removeFloatingVueAriaDescribedBy(), this.$nextTick(() => {
        this.$emit("after-show"), this.useFocusTrap(), this.addEscapeStopPropagation();
      });
    },
    afterHide() {
      this.$emit("after-hide"), this.clearFocusTrap(), this.clearEscapeStopPropagation();
    }
  }
};
var m = function() {
  var t = this, r = t._self._c;
  return r("Dropdown", t._g(t._b({ ref: "popover", attrs: { distance: 10, "arrow-padding": 10, "no-auto-focus": !0, "popper-class": t.popoverBaseClass, shown: t.internalShown }, on: { "update:shown": function(o) {
    t.internalShown = o;
  }, "apply-show": t.afterShow, "apply-hide": t.afterHide }, scopedSlots: t._u([{ key: "popper", fn: function() {
    return [t._t("default")];
  }, proxy: !0 }], null, !0) }, "Dropdown", t.$attrs, !1), t.$listeners), [r("NcPopoverTriggerProvider", { attrs: { shown: t.internalShown, "popup-role": t.popupRole }, scopedSlots: t._u([{ key: "default", fn: function(o) {
    return [t._t("trigger", null, null, o)];
  } }], null, !0) })], 1);
}, w = [], v = /* @__PURE__ */ n(
  f,
  m,
  w,
  !1,
  null,
  null,
  null,
  null
);
const E = v.exports;
export {
  E as N
};
